module.exports = __webpack_public_path__ + "static/ofertas_pubicas-d33349b36f6c47faa5fcdf8889184aac.jpg";